// 生成随机的Hex颜色
export function getRandomHexColor(): string {
  return `#${parseInt(String(Math.random() * 0xffffff), 10).toString(16)}`;
}

// 生成对比色
export function generateContrastColor(str: string) {
  // 将字符串转换为哈希值
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }

  // 计算颜色值
  let color = '#';
  for (let i = 0; i < 3; i++) {
    let value = (hash >> (i * 8)) & 0xff;
    value -= 64; // 将颜色值调整为较暗的颜色
    if (value < 0) {
      value = 0;
    }
    color += value.toString(16).padStart(2, '0');
  }

  return color.slice(0, 7); // 截取前七位，确保输出的颜色是一个有效的颜色值
}
